<template>
    <div class="d-flex flex-row justify-content-start gap-3">
        <div
            v-if="record.status_name === 'left'"
            class="status_selector_one_icon mx-auto p-2 mb-3 rounded text-center selected"
        >
            <icon :icon="getStatusByName('left')?.icon" class="status_icon" />
            <div class="fs-6 fw-bold">{{ $t("status." + statusType + ".left") }}</div>
        </div>

        <template v-else>
            <div
                v-for="status in statuses"
                :key="status.id"
                class="status_selector_icon p-2 mb-3 rounded text-center"
                :class="{ 'selected': record.status === status.id}"
                @click="changeStatus(status.id)"
            >
                <icon :icon="status.icon" class="status_icon" />
                <div class="fs-6 fw-bold">{{ $t("status." + statusType + "." + status.name) }}</div>
                <input
                    type="radio"
                    class="d-none"
                    :checked="record.status === status.id"
                >
            </div>
        </template>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue'

export default {
    components: {
        Icon,
    },
    props: {
        record: Object,
        statusType: String,
        getUrl: String,
        submitUrl: String,
        modalId: String,
    },
    data() {
        return {
            statuses: [],
        }
    },
    created() {
        this.getStatuses();
    },
    methods: {
        getStatuses() {
            this.$store.getters.api.get(this.getUrl)
            .then(response => {
                this.statuses = response.data;
            })
            .catch(error => {
                console.error("Error loading statuses", error);
            });
        },
        changeStatus(statusId) {
            this.$store.getters.api.patch(this.submitUrl, { status: statusId })
            .then((res) => {
                Object.assign(this.record, res.data);
                this.$emit("status-updated", res.data);
                this.$emit("close-modal")
            })
            .catch(error => {
                console.error("Failed to update status", error);
            });
        },
        getStatusByName(name) {
            return this.statuses.find(status => status.name === name);
        },
    }
}
</script>

<style scoped>
    .status_icon {
        width: 40px;
        height: 40px;
    }
</style>